module.exports = __webpack_public_path__ + "img/SOKAL-SRS-120921-Ram1500-Established.abbbb0ca.jpeg";